import styled from "styled-components";
import { t } from "i18next";
import React, { FC } from "react";
import { TFile } from "@brg/api";
import { Colors } from "@brg/ui";
import ResizedImageEnhanced from "../../ResizedImageEnhanced";
import { LayoutConst } from "../../../../core";
import { AppTester } from "supporting";

const Container = styled.div`
    height: 297px;
    width: 100%;
    display: flex;
    gap: 24px;
    background: ${(p) => {
        if (AppTester.isMediiia()) return Colors.gal;
        if (AppTester.isDeziiign()) return Colors.galBlack5;
        if (AppTester.isCGRAVE()) return Colors.zelWhite10;
        if (AppTester.isGeograffee()) return Colors.geoWhite10;
        return p.theme.mainDropdownStyles.bg;
    }};
    flex-direction: row;

    @media (max-width: ${LayoutConst.screen.l}px) {
        height: 183px;
    }

    @media (max-width: ${LayoutConst.screen.s}px) {
        flex-direction: column;
        height: 100%;
        gap: 0;
    }
`

const ImageContainer = styled.div`
    flex: 0 0 calc(50% - 12px);
    height: 100%;
    flex-shrink: 0;
    
    @media (max-width: ${LayoutConst.screen.s}px) {
        flex: 0 0 calc(50% - 8px);
        max-height: 169px;
    }
`

const CoverImage = styled(ResizedImageEnhanced)`
    width: 100%;
    height: 100%;
    img {
        object-fit: cover;
        width: 100%;
        height: 100%;
    }
`

const TextContainer = styled.div`
    flex: 0 0 calc(50% - 12px);
    display: flex;
    padding: 24px 40px 24px 0;
    flex-direction: column;
    justify-content: space-between;
    min-width: 0;

    @media (max-width: ${LayoutConst.screen.l}px) {
        padding: 16px 40px 16px 0;
    }
    
    @media (max-width: ${LayoutConst.screen.s}px) {
        flex: 0;
        padding: 10px 16px 16px 10px;
    }
`

const MaterialName = styled.p`
    font-size: 17px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px;
    
    letter-spacing: -0.34px;
    margin: 0;
    color: ${(p) => p.theme.navigationBar.search.color};

    @media (max-width: ${LayoutConst.screen.l}px) {
        font-size: 16px;
    }
    
    @media (max-width: ${LayoutConst.screen.s}px) {
        font-size: 15px;
    }
`

const MaterialTitle = styled.p`
    font-size: 22px;
    font-style: normal;
    font-weight: 600;
    line-height: 28px;
    letter-spacing: -0.44px;
    margin-top: 8px;
    color: ${(p) => p.theme.navigationBar.search.color};
    @media (max-width: ${LayoutConst.screen.l}px) {
        font-size: 17px;
        margin-top: 4px;
    }
    @media (max-width: ${LayoutConst.screen.s}px) {
        margin-top: 4px;
        margin-bottom: 16px;
    }
`

const MaterialTBtnLinkContainer = styled.div`
    display: flex;
    gap: 4px;
    flex-direction: row;
    align-items: baseline;

    @media (max-width: ${LayoutConst.screen.l}px) {
        font-size: 15px;
    }
`

const MaterialTBtnLink = styled.p`
    font-size: 17px;
    font-style: normal;
    font-weight: 600;
    line-height: 22px;
    letter-spacing: -0.34px;
    margin: 0;
    color: ${(p) => p.theme.mainDropdownStyles.color};

`

const ArrowSvg = () => {
  return (
    <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1.21474 8L0 6.78603L5.12833 1.65587H1.27573L1.2859 0H8V6.71492H6.33291L6.34307 2.86984L1.21474 8Z" fill="#909090"/>
    </svg>
  )
}


type PartnersMaterialProps = {
  name?: string;
  title?: React.ReactNode;
  files?: TFile[];
  alt?: string;
};

const PartnersMaterial: FC<PartnersMaterialProps> = ({ name, title, files, alt }) => {
  return (
    <Container>
      <ImageContainer>
        <CoverImage
          files={files}
          alt={alt}
          showEmptyPlaceholder
        />
      </ImageContainer>
      <TextContainer>
        <div>
          <MaterialName>{name}</MaterialName>
          <MaterialTitle>{title}</MaterialTitle>
        </div>
        <MaterialTBtnLinkContainer>
          <MaterialTBtnLink>{t('pagination.go')}</MaterialTBtnLink>
          <ArrowSvg/>
        </MaterialTBtnLinkContainer>
      </TextContainer>
    </Container>
  )
}

export default PartnersMaterial;import styled from "styled-components";
import { t } from "i18next";
import React, { FC } from "react";
import { TFile } from "@brg/api";
import { Colors } from "@brg/ui";
import ResizedImageEnhanced from "../../ResizedImageEnhanced";
import { LayoutConst } from "../../../../core";
import { AppTester } from "supporting";

const Container = styled.div`
    height: 297px;
    width: 100%;
    display: flex;
    gap: 24px;
    background: ${(p) => {
        if (AppTester.isMediiia()) return Colors.gal;
        if (AppTester.isDeziiign()) return Colors.galBlack5;
        if (AppTester.isCGRAVE()) return Colors.zelWhite10;
        if (AppTester.isGeograffee()) return Colors.geoWhite10;
        return p.theme.mainDropdownStyles.bg;
    }};
    flex-direction: row;

    @media (max-width: ${LayoutConst.screen.l}px) {
        height: 183px;
    }

    @media (max-width: ${LayoutConst.screen.s}px) {
        flex-direction: column;
        height: 100%;
        gap: 0;
    }
`

const ImageContainer = styled.div`
    flex: 0 0 calc(50% - 12px);
    height: 100%;
    flex-shrink: 0;
    
    @media (max-width: ${LayoutConst.screen.s}px) {
        flex: 0 0 calc(50% - 8px);
        max-height: 169px;
    }
`

const CoverImage = styled(ResizedImageEnhanced)`
    width: 100%;
    height: 100%;
    img {
        object-fit: cover;
        width: 100%;
        height: 100%;
    }
`

const TextContainer = styled.div`
    flex: 0 0 calc(50% - 12px);
    display: flex;
    padding: 24px 40px 24px 0;
    flex-direction: column;
    justify-content: space-between;
    min-width: 0;

    @media (max-width: ${LayoutConst.screen.l}px) {
        padding: 16px 40px 16px 0;
    }
    
    @media (max-width: ${LayoutConst.screen.s}px) {
        flex: 0;
        padding: 10px 16px 16px 10px;
    }
`

const MaterialName = styled.p`
    font-size: 17px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px;
    
    letter-spacing: -0.34px;
    margin: 0;
    color: ${(p) => p.theme.navigationBar.search.color};

    @media (max-width: ${LayoutConst.screen.l}px) {
        font-size: 16px;
    }
    
    @media (max-width: ${LayoutConst.screen.s}px) {
        font-size: 15px;
    }
`

const MaterialTitle = styled.p`
    font-size: 22px;
    font-style: normal;
    font-weight: 600;
    line-height: 28px;
    letter-spacing: -0.44px;
    margin-top: 8px;
    color: ${(p) => p.theme.navigationBar.search.color};
    @media (max-width: ${LayoutConst.screen.l}px) {
        font-size: 17px;
        margin-top: 4px;
    }
    @media (max-width: ${LayoutConst.screen.s}px) {
        margin-top: 4px;
        margin-bottom: 16px;
    }
`

const MaterialTBtnLinkContainer = styled.div`
    display: flex;
    gap: 4px;
    flex-direction: row;
    align-items: baseline;

    @media (max-width: ${LayoutConst.screen.l}px) {
        font-size: 15px;
    }
`

const MaterialTBtnLink = styled.p`
    font-size: 17px;
    font-style: normal;
    font-weight: 600;
    line-height: 22px;
    letter-spacing: -0.34px;
    margin: 0;
    color: ${(p) => p.theme.mainDropdownStyles.color};

`

const ArrowSvg = () => {
  return (
    <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1.21474 8L0 6.78603L5.12833 1.65587H1.27573L1.2859 0H8V6.71492H6.33291L6.34307 2.86984L1.21474 8Z" fill="#909090"/>
    </svg>
  )
}


type PartnersMaterialProps = {
  name?: string;
  title?: React.ReactNode;
  files?: TFile[];
  alt?: string;
};

const PartnersMaterial: FC<PartnersMaterialProps> = ({ name, title, files, alt }) => {
  return (
    <Container>
      <ImageContainer>
        <CoverImage
          files={files}
          alt={alt}
          showEmptyPlaceholder
        />
      </ImageContainer>
      <TextContainer>
        <div>
          <MaterialName>{name}</MaterialName>
          <MaterialTitle>{title}</MaterialTitle>
        </div>
        <MaterialTBtnLinkContainer>
          <MaterialTBtnLink>{t('pagination.go')}</MaterialTBtnLink>
          <ArrowSvg/>
        </MaterialTBtnLinkContainer>
      </TextContainer>
    </Container>
  )
}

export default PartnersMaterial;